// extracted by mini-css-extract-plugin
export var active = "_3p-7";
export var container = "_3p-0";
export var evenWidth = "_3p-4";
export var large = "_3p-5";
export var outlet = "_3p-8";
export var slide = "_3p-2";
export var small = "_3p-6";
export var tab = "_3p-3";
export var tabs = "_3p-1";